module.exports = __webpack_public_path__ + "img/KTP.53407c2c.png";